<template>
  <svg
    :width="width"
    :height="height"
    viewBox="0 0 24 24"
    class="icon-chevron-left"
    :class="[`icon-chevron-left--color-${color}`]"
  >
    <path d="M15.41,16.58L10.83,12L15.41,7.41L14,6L8,12L14,18L15.41,16.58Z" />
  </svg>
</template>

<script>
  export default {
    name: 'IconChevronLeft',
    props: {
      width: {
        type: [Number, String],
        default: '24',
      },
      height: {
        type: [Number, String],
        default: '24',
      },
      color: {
        type: String,
        default: 'white',
        validator: (value) => ['white', 'black'].includes(value),
      },
    },
  };
</script>

<style lang="scss" scoped>
  .icon-chevron-left {
    fill: currentColor;

    &--color-white {
      fill: white;
    }
    &--color-black {
      fill: black;
    }
  }
</style>
